import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/quiz/RealFake.css";

// ChallengePage presents two options to the user:
// 1. A Real/Fake quiz about political claims
// 2. A scenario-based quiz exploring misinformation
// Each option has a description and a navigation button

const ChallengePage = () => {
  const navigate = useNavigate(); // Hook to programmatically navigate between routes

  return (
    <div className="challenge-container text-center">
      {/* Page title */}
      <h1 className="challenge-title mb-2">
        Enhance Your Digital Citizenship Skills
      </h1>

      {/* Page subtitle */}
      <p className="challenge-subtitle mb-5">
        Learn to navigate the digital information landscape with confidence
      </p>

      {/* Quiz options laid out in two responsive boxes */}
      <div className="row justify-content-center mb-5">
        {/* Real/Fake Quiz option */}
        <div className="col-md-5 m-3 challenge-box">
          <img
            src="/icons/quiz.png"
            alt="Quiz Icon"
            className="mb-3"
            style={{ height: "50px" }}
          />
          <p>
            Test Your Ability To Identify True And False Political Claims With
            Our Fact-Checking Quiz.
          </p>
          {/* Navigate to /quiz on click */}
          <button className="start-button" onClick={() => navigate("/quiz")}>
            START QUIZ
          </button>
        </div>

        {/* Scenario Quiz option */}
        <div className="col-md-5 m-3 challenge-box">
          <img
            src="/icons/scenario.png"
            alt="Scenario Icon"
            className="mb-3"
            style={{ height: "50px" }}
          />
          <p>
            Experience Realistic Scenarios And Learn How Your Choices Impact The
            Spread Of Misinformation.
          </p>
          {/* Navigate to /scenario on click */}
          <button
            className="start-button"
            onClick={() => navigate("/scenario")}
          >
            START SCENARIO
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChallengePage;
